import {CancelToken} from '../../../libs/shared/core/src/helpers/utilities/asyncCancelHelpers';
import {HttpResponseError} from '../../../libs/shared/core/src/services/http/httpError';
import {isRawBoot} from '../../../src/models/api/rawBootModel';
import {
  FetchBootResult,
  fetchRawBootAsync,
  fetchRawBootInPartsAsync,
  readDataFromBoot,
} from './fetch/bootFetchHelpers';
import {tryReplaceRawBootCache} from './rawBootCacheHelpers';

/*
 * Types.
 */

interface FetchBootRefreshOptions {
  deltasSince: number;
  refreshToken: string | undefined;
  hasServiceWorkerBootCachePatching?: boolean;
  cancelToken?: CancelToken;
}

/*
 * Helpers.
 */

export async function fetchBootRefreshAsync(
  companyUrl: string,
  options: FetchBootRefreshOptions,
): Promise<FetchBootResult> {
  const rawBoot = await fetchRawBootRefreshAsync(companyUrl, options);

  // We may have gotten a full boot. If so, cache it!
  if (isRawBoot(rawBoot)) {
    tryReplaceRawBootCache(rawBoot);
  }

  return readDataFromBoot(rawBoot, true);
}

export async function fetchRawBootRefreshAsync(
  companyUrl: string,
  options: FetchBootRefreshOptions,
): Promise<unknown> {
  try {
    // Try to fetch a delta boot.
    // Note: we don't patch the previously cached boot here because it is slow, but we may do it in the service worker.
    return await fetchRawBootAsync(companyUrl, options);
  } catch (error) {
    // The server is telling us to fetch a full boot instead.
    if (options.refreshToken !== undefined && error instanceof HttpResponseError && error.status === 409) {
      return await fetchRawBootInPartsAsync(companyUrl, options.cancelToken);
    }

    throw error;
  }
}
